/**
 * `Project.customer` fields saved by the block project-customer-additional-information. Must match
 * `ProjectCustomerAdditionalInformationInput` in the API schema.
 */
export const PROJECT_CUSTOMER_ADDITIONAL_INFORMATION_CUSTOMER_INPUT_FIELDS = [
  'field',
  'fieldSector',
  'boundary',
  'electricMeterNumbers',
];

/** Top-level fields the page save leaves out (plan docs/work/_done/2026-10-project-block-customer-additional-information). */
export const PROJECT_CUSTOMER_ADDITIONAL_INFORMATION_TOP_LEVEL_FIELDS = ['customerDescription'];

const hasText = (value) => (value ?? '').trim() !== '';

/** Entries as `ElectricMeterNumberInput`; entries without number and note are dropped. */
const electricMeterNumbersInput = (electricMeterNumbers) =>
  (electricMeterNumbers ?? [])
    .filter((entry) => hasText(entry.number) || hasText(entry.description))
    .map((entry) => ({ number: entry.number ?? '', description: entry.description ?? '' }));

/**
 * `ProjectCustomerAdditionalInformationInput` from the block object (or the stored project): land
 * register fields of `customer` and notes, a missing field as `null`; the meter list without empty
 * entries.
 */
export const toProjectCustomerAdditionalInformationInput = (project) => {
  const customer = project.customer ?? {};

  return {
    field: customer.field ?? null,
    fieldSector: customer.fieldSector ?? null,
    boundary: customer.boundary ?? null,
    electricMeterNumbers: electricMeterNumbersInput(customer.electricMeterNumbers),
    customerDescription: project.customerDescription ?? null,
  };
};
